<template>
  <v-layout
    align-center
    justify-center
    role="region"
  >
    <v-flex
      xs11
      sm11
      md11
      md4
      lg4
    >
      <v-card
        color="secondary"
        class="pa-4"
        elevation="2"
        role="form"
        aria-labelledby="reset-password-heading"
      >
        <v-app-bar flat>
          <v-toolbar-title
            id="reset-password-heading"
            class="text-body-2"
          >
            {{ $t('components.resetPass.title') }}
          </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                :aria-label="$t('components.resetPass.buttons.signin')"
                small
                color="accent"
                :to="toSignInLink"
                v-bind="attrs"
                v-on="on"
              >
                {{ $t('components.resetPass.buttons.signin') }}
              </v-btn>
            </template>
            <span>{{ $t('components.resetPass.buttons.signin') }}</span>
          </v-tooltip>
        </v-app-bar>

        <v-container
          fluid
          grid-list-md
        >
          <!-- Loading Indicator -->
          <v-progress-linear
            v-show="isLoading"
            color="accent"
            indeterminate
            role="status"
            aria-label="Loading"
            class="mb-3"
          />

          <!-- Error messages -->
          <div
            v-if="hasErrors"
            role="alert"
            aria-live="assertive"
            class="mb-4"
          >
            <div
              v-for="(errorsGroup, errorsGroupIndex) in filteredErrors"
              :key="errorsGroupIndex"
            >
              <v-alert
                v-for="error in errorsGroup"
                :key="error.id"
                :type="error.type"
                :icon="error.icon"
              >
                {{ error.msg }}
              </v-alert>
            </div>
          </div>

          <!-- Form -->
          <v-form
            ref="form"
            aria-describedby="form-description"
            @submit.prevent="validate"
          >
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  v-model="form.email"
                  v-validate="'required|min:6|max:255'"
                  prepend-icon="fal fa-envelope"
                  color="accent"
                  data-vv-as="email or username"
                  data-vv-name="email"
                  :error-messages="errors.collect('email')"
                  :label="$t('components.resetPass.form.userOrEmail')"
                  name="email"
                  type="text"
                  autocomplete="username"
                  aria-required="true"
                  required
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer />
              <v-btn
                :aria-label="$t('components.resetPass.buttons.reset')"
                color="accent"
                type="submit"
              >
                {{ $t('components.resetPass.buttons.reset') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { filterByKeys } from "@/utils/object.utils";
import Validator from "@/modules/validator.module";
import blacklist from "@/constants/blacklist";
import links from "@/constants/links";

const ValidatorModule = new Validator();

export default {
  name: "ResetLinkLayout",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ValidationProvider
  },
  inject: ["$validator"],
  data() {
    return {
        form: {
            email: ""
        },
        isLoading: false
    }
  },
  computed: {
    filteredErrors() {
      return filterByKeys(
        this.$validator.errors.collect(),
        blacklist.forms.resetLink
      );
    },
    toSignInLink() {
      return links.routes.login;
    }
  },
  methods: {
    validate() {
      this.isLoading = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$api
            .resetLink(this.form.email)
            .then(res => {
              this.isLoading = false;
              // Add to the validator
              ValidatorModule.add("resetLink", res);
            })
            .catch(() => {
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "~/_variables.scss";

.reset-link {
  background-image: url("https://gm.goz.fun/wp-content/uploads/2023/03/reset-link-cover.png");
  background-size: cover;
  background-position: center center;
}
</style>
